import { DateFormat, PageMarginSize, SectionSpacingSize } from "@/types/resume";
import { ITemplateItem } from "./types";

export const templates: ITemplateItem[] = [
  {
    id: "banking",
    name: "Banking",
    imageName: "template-banking.png",
    categories: ["Banking", "Finance"],
    styles: {
      GLOBAL: {
        fontFamily: "Times New Roman, serif",
        fontSize: "small",
        backgroundColor: "#FFFFFF",
        showIcons: true,
        underlineSectionHeadings: true,
        dateLocationPosition: "row",
        dateLocationLayout: "column",
        dateFormat: DateFormat.MED,
        headingFontSize: "medium",
        pageMarginSize: PageMarginSize.SM,
        sectionSpacingSize: SectionSpacingSize.SM,
        themeColor: "#FFFFFF",
      },
    }
  },
  {
    id: "management",
    name: "Management",
    imageName: "template-management.png",
    categories: ["Management", "Business"],
    styles: {
      GLOBAL: {
        fontFamily: "Cambria, serif",
        fontSize: "small",
        backgroundColor: "#FFFFFF",
        showIcons: false,
        underlineSectionHeadings: false,
        dateLocationPosition: "row",
        dateLocationLayout: "row",
        dateFormat: DateFormat.MED,
        headingFontSize: "medium",
        pageMarginSize: PageMarginSize.SM,
        sectionSpacingSize: SectionSpacingSize.SM,
        themeColor: "#FFFFFF",
      },
    }
  },
  {
    id: "student",
    name: "Student/Part Time",
    imageName: "template-student.png",
    categories: ["Student", "Part Time"],
    styles: {
      GLOBAL: {
        fontFamily: "Poppins, sans-serif",
        fontSize: "small",
        showIcons: true,
        underlineSectionHeadings: true,
        dateLocationPosition: "row",
        dateLocationLayout: "column",
        dateFormat: DateFormat.LRG,
        headingFontSize: "medium",
        pageMarginSize: PageMarginSize.SM,
        sectionSpacingSize: SectionSpacingSize.SM,
        themeColor: "#F8F5EC",
      },
    }

  },
];